class ListJobs {

    constructor(element) {
        console.log('ListJobs.constructor 6', element);
        this.element = element;
        this.filterItems = this.element.getElementsByClassName('list-jobs-filter')[0].getElementsByTagName('a');
        this.tableItems = this.element.getElementsByClassName('list-jobs-item');

        this.btnClickHandler = this.btnClickHandler.bind(this);
        for (let i = 0; i < this.filterItems.length; i++) {
            this.filterItems[i].addEventListener("click", this.btnClickHandler);
        }
    }

    destroy() {
        console.log('ListJobs.destroy', this.element);
        for (let i = 0; i < this.filterItems.length; i++) {
            this.filterItems[i].removeEventListener("click", this.btnClickHandler);
        }
    }

    hideItems() {
        console.log('ListJobs.hideItems');
        for (let i = 0; i < this.tableItems.length; i++) {
            this.tableItems[i].classList.add('hidden');
        }
    }

    showItems() {
        console.log('ListJobs.showItems');
        for (let i = 0; i < this.tableItems.length; i++) {
            this.tableItems[i].classList.remove('hidden');
        }
    }

    showItemsByName(name) {
        console.log('ListJobs.showItemsByName', name);
        this.tableItemsByName = this.element.getElementsByClassName('list-jobs-item ' + name);
        console.log(this.tableItemsByName);
        for (let i = 0; i < this.tableItemsByName.length; i++) {
            this.tableItemsByName[i].classList.remove('hidden');
        }
    }

    btnClickHandler(event) {
        console.log('ListJobs.btnClickHandler', event, event.currentTarget);
        event.preventDefault();
        let currentFilter = event.currentTarget.getAttribute('data-filter')
        console.log('ListJobs.btnClickHandler', currentFilter);

        for (let i = 0; i < this.filterItems.length; i++) {
            this.filterItems[i].classList.remove('selected');
        }
        event.currentTarget.classList.add('selected');

        if (currentFilter === 'all') {
            this.showItems();
        } else {
            this.hideItems();
            this.showItemsByName(currentFilter);
        }
    }
}

ListJobs.elementClassName = 'list-jobs';
ListJobs.instances = [];
ListJobs.init = function() {
    console.log('ListJobs.init');
    var elements = document.getElementsByClassName( ListJobs.elementClassName );
    for (const element of Array.from(elements)) {
        ListJobs.instances.push(new ListJobs(element));
    }
    console.log('ListJobs.instances.length', ListJobs.instances.length);
};

ListJobs.onDispose = function() {
    console.log('ListJobs.onDispose');
    while (ListJobs.instances.length){
        console.log('ListJobs.instances.length', ListJobs.instances.length);
        let instance = ListJobs.instances.pop();
        instance.destroy();
        instance = null;
    }
};

export default ListJobs;


if (module.hot) {
    module.hot.dispose(ListJobs.onDispose);
}


